__webpack_require__.p = "/wp-content/themes/pratt-main/dist/";